<template>
  <div>
    <Loader />
    <div class="backdrop"></div>
    <main class="flex-shrink-0 main has-footer">
      <header class="header">
        <div class="row">
          <div class="col-auto px-0">
            <button
              class="btn btn-40 btn-link back-btn"
              type="button"
              @click="$router.push('/sobre')"
            >
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
          </div>
          <div class="text-left col align-self-center">
            <a class="navbar-brand">
              <h5 class="mb-0">Sobre a Cidade</h5>
            </a>
          </div>
        </div>
      </header>

      <div class="main-container" v-if="cardsCidadeSobre && cardsCidadeSobre.length > 0">
        <div class="container">
          <div class="row">
            <!-- Ítens sobre a cidade -->
            <div class="col-12 my-2"
              v-for="(cardCidadeSobre, idx) in cardsCidadeSobre" :key="idx"
            >
              <div class="ponteiro">
                <cidade-sobre-card :cardCidadeSobre="cardCidadeSobre"
                  :index="idx"
                >
                </cidade-sobre-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cardsCidadeSobre && cardsCidadeSobre.length == 0">
        <div class="container mb-1 mt-3 text-center text-white">
          <h5 class="mb-4">
            <span class="material-icons icon">receipt</span>
            {{ $t("sempromocaotitulo") }}
          </h5>
          <h6>{{ $t("sempromocaotexto") }}</h6>
        </div>
      </div>      
    </main>
  </div>
</template>

<script>
import Loader from "./Loader.vue";
import CONSTANTS from "../constants";
import axios from "axios";
import CidadeSobreCard from './CidadeSobreCard.vue';

export default {
  components: {
    Loader,
    CidadeSobreCard,
  },
  data() {
    return {
      cardsCidadeSobre: [],
      headers: {
        "x-access-token": this.$store.getters.GetLoginInfo.token,
      },
    };
  },
  methods: {
    carregarCidadeSobre() {
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/cidadesobre/select",
          {
            idhotel: this.$store.getters.GetLoginInfo.idhotel,
            idioma: this.$i18n.locale,
            ativo: true
          },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            this.cardsCidadeSobre = response.data;
            console.log(this.cardsCidadeSobre);
          }
        })
        .catch((err) => {
          console.log({ err_menu: err });
        });
    },
  },
  mounted() {
    this.carregarCidadeSobre();
  },
};
</script>

<style>
</style>